import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

export class AddressVerificationAnalytics extends BaseAnalytics {
    constructor(category = 'address_verification') {
        super();
        this.category = category;
    }

    clickedAddressVerification() {
        this.send('click address verification');
    }

    addressVerification(label: string) {
        this.send('address verification', label);
    }

    confirmCheckAddress() {
        this.send('step_check_address', 'confirm');
    }

    addressInputFieldsCallback(action: string) {
        this.send(action);
    }
}
